import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsSearch = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <path
        fill="currentColor"
        d="M16.2644672,10.2914286c0.0234661-1.5858669-0.6100569-3.1108112-1.7503376-4.2132106
	c-1.1030493-1.1388845-2.6279106-1.770999-4.2132101-1.7465396c-1.5858669-0.023468-3.1108117,0.6100554-4.2132111,1.7503362
	c-1.1379156,1.1021409-1.7699461,2.6254258-1.7465396,4.209414c-0.0255132,1.5866137,0.6066847,3.1130505,1.7465396,4.2170076
	c1.1023984,1.1402807,2.6273441,1.7738037,4.2132111,1.7503376c1.585866,0.0234661,3.1108122-0.6100569,4.2132101-1.7503376
	C15.6553812,13.4051304,16.2889881,11.8786077,16.2644672,10.2914286 M23.0759716,21.3655014
	c-0.0068626,0.9392834-0.7655087,1.6996193-1.7047749,1.7085724c-0.4534683,0.0101242-0.8896313-0.1741047-1.1985321-0.5062428
	l-4.5675802-4.5561905c-1.5569725,1.0892277-3.4154987,1.6644859-5.3155546,1.6452904
	c-1.2517185,0.004652-2.4911938-0.2464294-3.6424217-0.7378502c-2.256382-0.9339848-4.0495281-2.7257633-4.9852324-4.9814339
	c-0.9843353-2.3280888-0.9843353-4.9554892,0-7.283577C2.1275563,5.5365448,2.8063099,4.520349,3.6602716,3.6621714
	c0.8591466-0.852185,1.8745613-1.5307038,2.990633-1.9983957c2.3280888-0.9843355,4.9554892-0.9843355,7.283577,0
	c1.117075,0.4658241,2.1328287,1.1445701,2.990634,1.9983957c0.8521843,0.8591461,1.5307026,1.8745608,1.998394,2.9906325
	c0.490633,1.1501837,0.7421055,2.3881707,0.7391148,3.6386247c0.0170002,1.8997355-0.5580559,3.7576094-1.6452904,5.3155556
	l4.5663166,4.5663157c0.3239021,0.3121109,0.5032024,0.7450066,0.494854,1.1947346"
      />
    </SvgIcon>
  );
});

export default AppIconsSearch;
